module.exports = __webpack_public_path__ + "img/leftBoxbg.ac62bd30.png";